export default {
  text: '#282e37',
  primary: '#0d84d7',
  secondary: '#282e37',
  background: '#fdfdfd',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#020303'
}
